import { useAtomValue } from 'jotai'
import { ResultsGrid } from 'src/views/map-explorer/sidebar/related-results'

import * as coreAtoms from 'src/v2/state/core'
import * as searchAtoms from 'src/v2/state/map-explorer/search'
import { FC, useMemo, useState } from 'react'
import { FlexColumn, FlexRow } from 'src/components/flex-containers'
import { Colors, Shapes } from 'src/components/theme'
import { FormControlLabel, Typography } from '@mui/material'
import { AntSwitch } from 'src/components/switch'
import { useMapExplorerNavigation } from 'src/views/map-explorer/sidebar/search/use-navigation'
import { SidebarResultListItem } from 'src/v2/components/sidebar-result-list'

type NearbyResultsGridProps = {
  hideMobilityToggle?: boolean
}

export const NearbyResultsGrid: FC<NearbyResultsGridProps> = ({ hideMobilityToggle = false }) => {
  const [onlyMobility, setOnlyMobility] = useState(true)
  const selectedEntity = useAtomValue(coreAtoms.selectedEntity)
  const results = useAtomValue(searchAtoms.selectedEntityNearbyResults)
  const { selectLocation } = useMapExplorerNavigation()

  const onToggleMobility = () => {
    setOnlyMobility(!onlyMobility)
  }

  const onClick = async (item: SidebarResultListItem) => {
    await selectLocation(item.id)
  }

  const deduped = useMemo(() => {
    if (!results) {
      return undefined
    }
    let locations =
      selectedEntity?.type === 'SELECTED_LOCATION'
        ? results.locations.filter((l) => l.id !== selectedEntity.data['am-loc'].id)
        : results.locations

    let shoppingCenters =
      selectedEntity?.type === 'SELECTED_SHOPPING_CENTER'
        ? results.shoppingCenters.filter((l) => l.id !== selectedEntity.data['am-loc'].id && l.meta.hasMobility)
        : results.shoppingCenters

    locations = locations.filter((l) => l.meta.hasMobility === onlyMobility)
    shoppingCenters = shoppingCenters.filter((l) => l.meta.hasMobility === onlyMobility)
    return {
      locations,
      shoppingCenters,
      all: [...shoppingCenters, ...locations],
    }
  }, [results, selectedEntity, onlyMobility])

  if (!deduped) {
    return null
  }

  return (
    <FlexColumn gap={Shapes.spacing[4]}>
      <FlexRow align="center" gap={Shapes.spacing[4]}>
        <Typography variant="title1" color={Colors.neutral500}>
          Choose from nearby results
        </Typography>

        {!hideMobilityToggle && (
          <FormControlLabel
            style={{
              border: `1px solid ${Colors.border}`,
              borderRadius: `${Shapes.borderRadius}px`,
              padding: `${Shapes.spacing[1]}px`,
            }}
            control={<AntSwitch checked={onlyMobility} onChange={onToggleMobility} />}
            label={
              <Typography
                variant="title1"
                color={Colors.neutral500}
                style={{
                  marginLeft: Shapes.spacing[2],
                }}>
                {onlyMobility ? 'with mobility' : 'without mobility'}
              </Typography>
            }
          />
        )}
      </FlexRow>
      {deduped.all.length > 0 ? (
        <ResultsGrid deduped={deduped} onClick={onClick} mini={false} minWidth={200.5} />
      ) : (
        <Typography variant="textmdm" color={Colors.neutral500}>
          No results found
        </Typography>
      )}
    </FlexColumn>
  )
}
